<script setup lang="ts">
import type {
  ApiErrorEventDetail,
  StructuredApiErrorEventDetail,
  WbApiErrorEventDetail,
} from '@/shared/lib/utils/errorHandler'

import { onMounted, onUnmounted } from 'vue'
import { useCustomToast } from '@/shared/lib'
import {
  API_ERROR_EVENT,
  STRUCTURED_API_ERROR_EVENT,
  WB_API_ERROR_EVENT,
} from '@/shared/lib/utils/errorHandler'

const toast = useCustomToast()

// Handler function for API error events
function handleApiError(event: CustomEvent<ApiErrorEventDetail>) {
  const { title, message } = event.detail

  // Show the error in a toast notification
  toast.error({
    title,
    message,
  })
}

// Handler function for structured API error events
function handleStructuredApiError(
  event: CustomEvent<StructuredApiErrorEventDetail>,
) {
  const { title, message } = event.detail

  // Show the error in a toast notification
  toast.error({
    title,
    message,
  })
}

// Handler function for WB API error events
function handleWbApiError(event: CustomEvent<WbApiErrorEventDetail>) {
  const { title, message } = event.detail

  // Show the error in a toast notification
  toast.error({
    title,
    message,
  })
}

// Add and remove event listeners
onMounted(() => {
  window.addEventListener(
    API_ERROR_EVENT,
    handleApiError as (event: Event) => void,
  )
  window.addEventListener(
    STRUCTURED_API_ERROR_EVENT,
    handleStructuredApiError as (event: Event) => void,
  )
  window.addEventListener(
    WB_API_ERROR_EVENT,
    handleWbApiError as (event: Event) => void,
  )
})

onUnmounted(() => {
  window.removeEventListener(
    API_ERROR_EVENT,
    handleApiError as (event: Event) => void,
  )
  window.removeEventListener(
    STRUCTURED_API_ERROR_EVENT,
    handleStructuredApiError as (event: Event) => void,
  )
  window.removeEventListener(
    WB_API_ERROR_EVENT,
    handleWbApiError as (event: Event) => void,
  )
})
</script>

<template>
  <div>
    <!-- This component doesn't render anything, it just listens for error events -->
  </div>
</template>
